import { Link } from '@tanstack/react-router';
import * as React from 'react';
import { Button } from '../atoms/button';

type ErrorComponentProps = {
  error: Error;
}

export function ErrorComponent(props: ErrorComponentProps) {
    return <div className="flex flex-col justify-center items-center p-8">
      <h1 className="text-3xl text-red-800 font-bold mt-8">Something went wrong :(</h1>
      <div className="mt-4 text-center text-red-800">
        {props.error.message || 'We\'re not sure why this is happening, but we\'re working on it.'}
      </div>
      <div className="mt-8">
        <Link to="/">
          <Button variant="secondary">Go back to the home page</Button>
        </Link>
      </div>
    </div>;
}
